import { DataContext } from "@/types";
import { Data } from "../Data";
import { SettingRegulation } from "./SettingRegulation";

export class SettingsRegulationList extends Data {
  static instance: SettingsRegulationList | null = null;

  regulations: any;

  constructor(options: any) {
    const { apiUrl, ...otherOptions } = options;

    const apiOptions = {
      api: apiUrl,
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...otherOptions
    };

    super(apiOptions);
    this.regulations = [];
  }

  onDataReceived(data: any) {
    this.regulations = [];
    data.regulations.forEach((g: any, index: any) =>
      this.regulations.push(new SettingRegulation(g))
    );
  }

  static onGetData(context: DataContext, options: any) {
    const { apiUrl } = options;
    return new Promise((resolve, reject) => {
      SettingsRegulationList.instance = new SettingsRegulationList({
        apiUrl,
        resolve,
        reject,
        context
      });
    });
  }

  static getSettingRegulationList(context: DataContext, updateCache: boolean): Promise<SettingsRegulationList> {
    return new Promise((resolve, reject) => {
      if (SettingsRegulationList.instance && updateCache !== true)
        resolve(SettingsRegulationList.instance);
      else
        SettingsRegulationList.instance = new SettingsRegulationList({ resolve, reject, context });
    });
  }
}
